<app-custom-table
    [columns]="projectDepositsSettingsService.tableColumns"
    (sortEvent)="projectDepositsSettingsService.sortDeposits(dataSection().type, $event)">
    @for (deposit of dataSection().deposits; track deposit.id) {
        <tr (click)="projectDepositsSettingsService.toggleDepositDetailPanel(deposit.id)">
            @for (column of projectDepositsSettingsService.tableColumns; track column.key) {
                @switch (column.key) {
                    @case ('depositFolder') {
                        <td>{{ deposit.depositFolder.name }}</td>
                    }
                    @case ('layers') {
                        <td>{{ deposit.layers.length }}</td>
                    }
                    @case ('standard') {
                        <td>{{ deposit.standard?.name ?? '-' }}</td>
                    }
                    @case ('updatedAt') {
                        <td>{{ deposit[column.key] | translocoDate }}</td>
                    }
                    @default {
                        <td>{{ deposit[column.key] }}</td>
                    }
                }
            }
        </tr>
    } @empty {
        <tr>
            <td [attr.colspan]="projectDepositsSettingsService.tableColumns.length">
                <app-no-data-to-display
                    displayedMessage="noDataToShow"
                    iconSize="4x" />
            </td>
        </tr>
    }
</app-custom-table>
<div class="flex justify-start my-4">
    <app-paginator
        [page]="dataSection().pagination.page"
        [take]="dataSection().pagination.take"
        [totalItems]="dataSection().totalItems"
        (onPageChange)="projectDepositsSettingsService.changePage(dataSection().type, $event)" />
</div>
